import { ReactElement } from 'react';
import RunMap from '../../pages/RunView/RunDetails/RunMap';

interface CourseMapPlotProps {
  route: any;
  gates?: any;
}

export default function CourseMapPlot({ route, gates }: CourseMapPlotProps): ReactElement {
  if (!route) {
    return <div className="cr-p-4 cr-text-gray-500">No route data available</div>;
  }

  return (
    <div className="cr-rounded-xl cr-bg-clip-border cr-shadow-md cr-overflow-hidden" style={{ height: '300px' }}>
      <RunMap
        lats={route.route_lat}
        lons={route.route_lon}
        gates_lat={gates?.gates_lat}
        gates_lon={gates?.gates_lon}
      />
    </div>
  );
}
